export enum CHAT_STATUS {
    BOT = 0,
    PENDING,
    ASSIGNED,
    RESOLVED,
    BULK,
}

export const CHAT_STATUSES_NAMES = Object.keys(CHAT_STATUS).filter((k) => !k.match(/^\d+$/)) as (keyof typeof CHAT_STATUS)[];

export const CHAT_STATUSES_LIST = Object.values(CHAT_STATUS).filter((v) => typeof v === 'number') as CHAT_STATUS[];

export enum ChatAccessType {
    /**
     * Access to chat entity data but not messages
     */
    list = 'list',
    /**
     * Read-only direct access to chat and its messages
     */
    view = 'view',
    /**
     * Changing chat state - assign, resolve, etc.
     */
    manage = 'manage',
    /**
     * Sending messages in the chat
     */
    send = 'send',
}
